import React from "react";
import numeral from "numeral";
import "./styles.css";

const MetricCell = ({
  format = "CURRENCY", // CURRENCY or PERCENT for now
  value,
  label = "Market Value"
}) => {
  let display = "";
  if (value === null) {
    display = "--";
  } else {
    display = format === "CURRENCY" ? numeral(value).format("$0,00") : numeral(value).format("0.00%");
  }

  return (
    <div className="refi-proceeds-analysis-metric-cell-container">
      <div className="refi-proceeds-analysis-metric-cell-value-text">{display}</div>
      <div className="refi-proceeds-analysis-metric-cell-label-text">{label}</div>
    </div>
  );
};

export default MetricCell;
